import { heureka } from "@otto-ec/heureka";

export function registerFilterSectionChangedListener() {
  heureka.filterSection_change.on((event) => {
    document.getElementById(event.id).click();
  });
}
